// ProductMoreInfo.jsx
import React from "react";

export default function ProductMoreInfo({ isMobile }) {
  return (
    <div>
      {/* TABS */}
      <div
        style={{
          display: "flex",
          gap: isMobile ? "10px" : "15px",
          marginTop: "40px",
          flexWrap: "wrap",
          justifyContent: isMobile ? "center" : "flex-start",
        }}
      >
        <button style={activeTab}>Description</button>
        {/* <button style={tab}>Reviews</button>
        <button style={tab}>Resources</button> */}
      </div>

      {/* FULL DESCRIPTION */}
      <p style={{ marginTop: "20px" }}>
        Biofanas Tomato Powder is made from ripe, juicy tomatoes that are dehydrated and finely ground to preserve their natural flavour, vibrant colour, and 
essential nutrients. It serves as a convenient and shelf-stable alternative to fresh tomatoes, tomato puree, or paste — with no added preservatives or 
artificial colours.

      </p>

      <h3>Key Features:</h3>
      <ul>
        <li>Made from sun-ripened, premium-quality tomatoes</li>
        <li>Fine texture with bright red colour</li>
        <li>Long shelf life and easy to store</li>
        <li>Available in retail and bulk packaging</li>
      </ul>

      <h3>Nutritional Benefits:</h3>
      <ul>
        <li>Rich in Lycopene, a powerful antioxidant</li>
        <li>Good source of Vitamin C, potassium, and fibre</li>
        <li>Supports heart health, immunity, and skin health</li>
        <li>Acts as a natural flavour enhancer and Colourant</li>
        <li>Easy to rehydrate and blend into recipes</li>
      </ul>

      <h3>Applications:</h3>
      <ul>
      <li>Soups, sauces, and curries, Instant noodles, seasonings, and spice blends</li>
        <li>Ketchup, dips, and marinades, Bakery products </li>
        <li>Baby food and health supplements</li>
      </ul>

      <h3>Advantages:</h3>
      <ul>
        <li>Easy to measure and mix — no chopping or cooking needed</li>
        <li>Cost-effective and space-saving in industrial production</li>
        <li>Consistent flavour and quality in every batch</li>
      </ul>
    </div>
  );
}

const activeTab = {
  padding: "10px 20px",
  background: "green",
  color: "white",
  borderRadius: "8px",
  border: "none",
};

const tab = {
  padding: "10px 20px",
  borderRadius: "8px",
  border: "1px solid #ccc",
};
